import {
  getSimplifiedLevels,
  getTraditionalLevels,
} from "@-/dev.improve.haniverse.assets.graphemes.levels";
import onetime from "@-/com.npmjs.onetime";

export function buildAbsentMnemonicDescription(
  characterGloss: string,
  componentList: readonly { gloss: string; grapheme: string }[],
): string {
  const linkedCharacterGloss = `[${escapeMarkdownLinkLabel(characterGloss)}](.)`;
  if (componentList.length === 0) {
    return linkedCharacterGloss;
  }

  const linkedComponentGlossList = componentList.map(
    ({ gloss, grapheme }) => `_[${escapeMarkdownLinkLabel(gloss)}](${grapheme})_`,
  );

  return `${linkedComponentGlossList.join(" + ")} = ${linkedCharacterGloss}`;
}

export function buildAbsentMnemonicSubtext({
  canEdit = true,
  isInLevelsCurriculum,
}: {
  canEdit?: boolean;
  isInLevelsCurriculum: boolean;
}): string {
  return isInLevelsCurriculum
    ? "This character doesn't have a custom mnemonic yet, but we'll add one soon!"
    : canEdit
      ? "This character doesn't have a custom mnemonic, but feel free to add your own!"
      : "This character doesn't have a custom mnemonic yet.";
}

const getLevelsCurriculumGraphemes = onetime(() => {
  const graphemes = new Set<string>();
  for (const level of getSimplifiedLevels()) {
    for (const grapheme of level.characters) {
      graphemes.add(grapheme);
    }
  }
  for (const level of getTraditionalLevels()) {
    for (const grapheme of level.characters) {
      graphemes.add(grapheme);
    }
  }
  return graphemes;
});

/** True when the grapheme appears in the simplified or traditional levels curriculum. */
export function isGraphemeInLevelsCurriculum(grapheme: string): boolean {
  return getLevelsCurriculumGraphemes().has(grapheme);
}

function escapeMarkdownLinkLabel(value: string): string {
  return value
    .replaceAll("\\", String.raw`\\`)
    .replaceAll("[", String.raw`\[`)
    .replaceAll("]", String.raw`\]`);
}
